import { useUnistyles } from "react-native-unistyles";
import { Image } from "@src/components/Image";
import { ImageSource } from "expo-image/src/Image.types";
import { FC, memo } from "react";
import { BiometryType } from "@src/hooks/useBiometricAuth";
import { Platform } from "react-native";
import { View } from "@src/components/View";
import { Icon } from "@src/components/Icon";

type BiometricIconType = {
  biometryType: BiometryType;
};

const FaceIDSize = 80;
const TouchIDSize = 70;
const IrisSize = 70;

const TouchIDImage = require("../../../../assets/icons/fingerprint.png") as ImageSource;
const FaceIDIOSImage = require("../../../../assets/icons/faceID.png") as ImageSource;
const FaceIDAndroidImage = require("../../../../assets/icons/android-face.png") as ImageSource;

const BiometricIcon: FC<BiometricIconType> = memo(({ biometryType = "Face ID" }) => {
  const { theme } = useUnistyles();

  if (biometryType === "Iris") {
    return <Icon name="visibility" size={IrisSize} color={theme.colors.interactive.buttons.default_foreground} />;
  }

  if (biometryType === "Face ID" || biometryType === "Face Recognition") {
    return (
      <Image
        source={Platform.OS === "ios" ? FaceIDIOSImage : FaceIDAndroidImage}
        style={{
          width: FaceIDSize,
          height: FaceIDSize,
          tintColor: theme.colors.interactive.buttons.default_foreground,
        }}
      />
    );
  }

  if (biometryType === "Fingerprint" || biometryType === "Touch ID") {
    return (
      <Image
        source={TouchIDImage}
        style={{
          width: TouchIDSize,
          height: TouchIDSize,
          tintColor: theme.colors.interactive.buttons.default_foreground,
        }}
      />
    );
  }

  return <View style={{ width: FaceIDSize, height: FaceIDSize, backgroundColor: "transparent" }} />;
});

export default BiometricIcon;
